import '../styles/Home.css';
import Layout from '../layouts/Layout.js'
import '../styles/SquareSection.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Route } from 'react-router-dom';
import ThirdSection from '../components/paragraphs/ThirdSection';
import PresentationSection from '../components/paragraphs/PresentationSection';
import Skills from '../components/paragraphs/Skills';
import Passions from '../components/paragraphs/Passions';
import { Link } from "react-router-dom";

const Home = ({component: Component, ...rest}) => {
  return (
    <Route {...rest} render={props => (  
        <Layout child={
          <>
          <HomeContent></HomeContent>
          </>
        }>
        </Layout>
    )} /> 
  );
}

const HomeContent = () => {
  return (
    <div className="Home">
      <h1>Who am I ?</h1>
          <div className="RowSquaresSection">
            <div className="Half-div">
            <PresentationSection
              title="About me"
              content={"PhD Student in Web privacy.\nMy thesis studies redirect chains as a tracking mechanism and examines how they can be measured reliably.\nMy research interests include Web tracking, online advertising ecosystems, and privacy measurement methods."}
              img={process.env.PUBLIC_URL + '/profilePicture.png'}
              scholar={"https://scholar.google.com/citations?user=JvOXG5YAAAAJ"}
            />
            </div>
            <div className="Half-div">
              <ThirdSection
                title="Skills"
                content={<Skills/>}
              />
              <ThirdSection
                title="Passions"
                content={<Passions/>}
              />
            </div>
          </div>

          <div className="RowSquaresSection">
          <div className="Half-div">
          <h2  className="color-title">Current situation</h2>
              <ThirdSection
                title="PhD student"
                content={
                  <div className='currentSituation'>
                    <p>Univ. Rennes - Rennes(35)</p>
                    {/* <p>CLES 2 Certification. Equivalent to TOEIC B2</p> */}
                    <p>Web privacy</p>
                    <div>
                      <Link className="link" to={"/career"}>Learn more</Link>
                    </div>
                    <div>
                      <Link className="link" to={"/projects"}>See projects</Link>
                    </div>
                  </div>
                }
              />
              <ThirdSection
                title="Aprenticeship in software development"
                content={
                <div className='currentSituation'>
                  <p>Orange - Lannion(22)</p>
                  <p>From 2019 to 2023. Software and web development.</p>
                  <div>
                    <Link className="link" to={"/career"}>Learn more</Link>
                    </div><div>
                  <Link className="link" to={"/projects"}>See projects</Link>
                  </div>
                </div>
              }
              />
            </div>
            <div className="Half-div">
            <h2 className="color-title">Latest projects</h2>
              <ThirdSection
                title="Remote Device Tool"
                content={<div className='currentSituation'>
                <p>Orange project</p>
                <p>Overhaul of the actual web app using Flutter. The main purpose is to learn Flutter which is a multi-platform framework.</p>
                <div>
                  <Link className="link" to={"/projects"}>Learn more</Link>
                </div>
              </div>
              }
              />
              <ThirdSection
               title="Java Enterprise Edition"
               content={<div className='currentSituation'>
               <p>ENSSAT project</p>
               <p>Deployed a web application to rent equipments using Java Enterprise Edition. </p>
               <div>
                 <Link className="link" to={"/projects"}>Learn more</Link>
               </div>
             </div>
             }
              />
            </div>
          </div>
        </div>
  );
} 

export default Home;
